import { useState, useEffect } from 'react';
import { supabase } from '../supabase';
 
const API = 'https://objectionready-production.up.railway.app';
 
const PLAN_NAMES = {
  'price_1TPq18Kvsr6YPyDcPE62Vb3C': 'Starter',
  'price_1TPqHbKvsr6YPyDcxNeJq7iy': 'Pro',
  'price_1TPqIZKvsr6YPyDc3qERJVaz': 'Elite',
  'price_1TPqJbKvsr6YPyDcoCCElzwO': 'Agency Starter',
  'price_1TPqK6Kvsr6YPyDcFa2YGmkg': 'Agency Pro',
  'price_1TPqKfKvsr6YPyDc5EtALQmv': 'Agency Elite',
};
 
export default function Copilot({ session }) {
  const [plan, setPlan] = useState(null);
  const [trial, setTrial] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [portalLoading, setPortalLoading] = useState(false);
 
  useEffect(() => {
    const handleMessage = (e) => {
      if (e.data === 'openPortal') handleManagePlan();
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);
 
  useEffect(() => {
    fetch(`${API}/stripe/status`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: session.user.email })
    })
    .then(r => r.json())
    .then(data => {
      if (data.active) {
        setPlan(PLAN_NAMES[data.plan] || data.plan);
        setTrial(data.trial);
      }
    });
  }, [session]);
 
  const handleSignOut = async () => {
    await supabase.auth.signOut();
  };
 
  const handleManagePlan = async () => {
    setPortalLoading(true);
    setShowMenu(false);
    try {
      const res = await fetch(`${API}/stripe/portal`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: session.user.email })
      });
      const data = await res.json();
      if (data.url) window.location.href = data.url;
    } catch (e) {
      alert('Something went wrong. Please try again.');
    }
    setPortalLoading(false);
  };
 
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: '#0c0c0d' }}>
      <div style={{ padding: '10px 16px', borderBottom: '0.5px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0, position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#4ade80', boxShadow: '0 0 8px #4ade80' }}></div>
          <span style={{ fontSize: '13px', fontWeight: '500', color: '#888880' }}>ObjectionReady</span>
          {plan && (
            <span style={{ fontSize: '10px', padding: '2px 8px', borderRadius: '99px', background: 'rgba(74,222,128,0.1)', border: '0.5px solid rgba(74,222,128,0.25)', color: '#4ade80', fontFamily: 'DM Mono, monospace' }}>
              {trial ? `${plan} · Trial` : plan}
            </span>
          )}
        </div>
        <div style={{ position: 'relative' }}>
          <button onClick={() => setShowMenu(!showMenu)} style={{ fontSize: '12px', color: '#555550', background: 'transparent', border: 'none', cursor: 'pointer', fontFamily: 'DM Sans, sans-serif' }}>
            {portalLoading ? 'Loading...' : 'Account ▾'}
          </button>
          {showMenu && (
            <div style={{ position: 'absolute', right: 0, top: '28px', background: '#141416', border: '0.5px solid rgba(255,255,255,0.12)', borderRadius: '8px', overflow: 'hidden', zIndex: 100, minWidth: '160px' }}>
              <div style={{ padding: '8px 12px', fontSize: '11px', color: '#555550', borderBottom: '0.5px solid rgba(255,255,255,0.08)' }}>{session.user.email}</div>
              <button onClick={handleManagePlan} style={{ width: '100%', padding: '10px 12px', fontSize: '12px', color: '#f0efe8', background: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left', fontFamily: 'DM Sans, sans-serif' }}>
                Manage subscription
              </button>
              <button onClick={handleSignOut} style={{ width: '100%', padding: '10px 12px', fontSize: '12px', color: '#f87171', background: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left', fontFamily: 'DM Sans, sans-serif', borderTop: '0.5px solid rgba(255,255,255,0.08)' }}>
                Sign out
              </button>
            </div>
          )}
        </div>
      </div>
      {plan !== null ? (
        <iframe
          key={plan}
          src={`/copilot.html?plan=${encodeURIComponent(plan || 'starter')}`}
          style={{ flex: 1, border: 'none', width: '100%', background: '#0c0c0d' }}
          title="Call Copilot"
          allow="microphone"
        />
      ) : (
        <div style={{ flex: 1, background: '#0c0c0d' }}></div>
      )}
    </div>
  );
}